const { default: pocketbase } = require("pocketbase");

let DGIIProcessor = null;
let checkPrintInFlight = false;

// Servicio local de impresión de cheques (ApiCheck en Windows). Se puede cambiar por
// equipo desde "Probar impresora" (localStorage) o para todos con VUE_APP_PRINT_API_URL.
const PRINT_API_KEY = "print_api_url";
const DEFAULT_PRINT_API = "http://localhost:5000/";
function printApiBase() {
  let base = "";
  try {
    base = (typeof localStorage !== "undefined" && localStorage.getItem(PRINT_API_KEY)) || "";
  } catch (e) {
    base = "";
  }
  base = base || process.env.VUE_APP_PRINT_API_URL || DEFAULT_PRINT_API;
  return base.endsWith("/") ? base : base + "/";
}

// fetch con límite de tiempo para las consultas rápidas al servicio (estado, impresoras).
async function fetchWithTimeout(resource, ms = 3000) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), ms);
  try {
    return await fetch(resource, { signal: controller.signal });
  } finally {
    clearTimeout(timer);
  }
}

function newPrintJobId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
}

// Error del API de impresión. `uncertain` = no se sabe si el lote llegó a la cola
// (red caída o error 500): NO reimprimir sin revisar el papel.
function printError(message, uncertain) {
  const error = new Error(message);
  error.uncertain = uncertain;
  return error;
}

// Función para cargar el procesador DGII de forma dinámica
async function loadDGIIProcessor() {
  if (!DGIIProcessor) {
    try {
      const module = await import('./dgii-main-optimized.js');
      DGIIProcessor = module.default || module.DGIIProcessor;

      if (!DGIIProcessor || typeof DGIIProcessor.process !== 'function') {
        throw new Error('El módulo DGIIProcessor no tiene el método process');
      }
    } catch (error) {
      console.error('Error cargando DGIIProcessor:', error);
      throw new Error(`No se pudo cargar el procesador DGII: ${error.message}`);
    }
  }
  return DGIIProcessor;
}


exports.install = function (Vue, options) {
  // Instalar la función get_dgii_json con manejo mejorado de errores



  const version = "1.0.0";
  const url = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_URL_PRODUCTION : process.env.VUE_APP_API_URL_DEV
  //const url =process.env.VUE_APP_API_URL_PRODUCTION
  const url_pocketbase = process.env.VUE_APP_POCKETBASE
  const pb = new pocketbase(url_pocketbase);

  const locationsAccess = JSON.parse(localStorage.getItem("locations_access"));
  Vue.prototype.get_dgii_json = async function (invoice_id) {
    try {


      // Verificación inicial de datos
      const invoiceCheckRequest = await this.api_Post("income/invoice_dgii", {
        invoice_id: invoice_id
      });

      if (!invoiceCheckRequest.ok) {
        throw new Error(`No se pudo obtener información de la factura: ${invoiceCheckRequest.status}`);
      }

      const invoiceData = await invoiceCheckRequest.json();
      if (!invoiceData || (Array.isArray(invoiceData) && invoiceData.length === 0)) {
        throw new Error(`La factura con ID ${invoice_id} no existe o no contiene datos`);
      }



      const processor = await loadDGIIProcessor();



      // Usar el procesador principal optimizado
      return await processor.process(this, invoice_id);

    } catch (error) {
      console.error('❌ Error en get_dgii_json optimizado:', error);

      // Log detallado para debugging
      console.error('Detalles del error:', {
        message: error.message,
        stack: error.stack,
        invoiceId: invoice_id
      });

      // Propagar el error para manejo en la interfaz
      throw error;
    }
  };

  Vue.prototype.api_print_check = async function (body) {


    const cabecera = {
      "Content-Type": "application/json",

    };

    const request = {
      method: "POST",
      headers: cabecera,
      body: JSON.stringify(body),
    };
    const response = await fetch(printApiBase() + "Print", request);
    return response;
  };
  // Renderizador genérico: el frontend envía las páginas/elementos ya maquetados.
  Vue.prototype.api_print_render = async function (body) {
    if (checkPrintInFlight) throw new Error("Ya hay un lote enviándose a impresión.");
    checkPrintInFlight = true;
    try {
      // Se conserva si el llamador vuelve a utilizar el mismo lote. Nunca reintentar automáticamente.
      if (!body.JobId) body.JobId = newPrintJobId();
      let response;
      try {
        response = await fetch(printApiBase() + "Print/render", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
      } catch (error) {
        throw printError(`No se pudo confirmar el lote ${body.JobId}. Revisa la cola y el papel antes de reimprimir; puede haberse enviado.`, true);
      }
      if (!response.ok) {
        const detail = await response.text();
        // 400/409: el API rechazó el lote sin imprimir. 5xx: resultado desconocido.
        throw printError(`Impresión: ${detail || response.status}`, response.status >= 500);
      }
      // Resultado del servicio (incluye el papel que usó el driver); no consume el cuerpo original.
      response.result = response.clone ? await response.clone().json().catch(() => null) : null;
      return response;
    } finally {
      checkPrintInFlight = false;
    }
  };
  Vue.prototype.new_print_job_id = newPrintJobId;
  Vue.prototype.print_api_base = printApiBase;
  // Guarda la URL del servicio para este equipo ("" = valor por defecto).
  Vue.prototype.set_print_api_base = function (value) {
    const clean = String(value || "").trim();
    if (clean && !/^https?:\/\/[^\s/]+(\/.*)?$/i.test(clean)) throw new Error("URL del servicio de impresión no válida.");
    if (clean) localStorage.setItem(PRINT_API_KEY, clean);
    else localStorage.removeItem(PRINT_API_KEY);
    return printApiBase();
  };
  // ¿Está encendido el servicio de impresión? { online, version, error }
  Vue.prototype.api_print_health = async function () {
    try {
      const response = await fetchWithTimeout(printApiBase() + "health", 2500);
      if (!response.ok) return { online: false, error: `El servicio respondió ${response.status}` };
      const data = await response.json().catch(() => ({}));
      return { online: true, version: data.version || null };
    } catch (error) {
      return { online: false, error: "No responde el servicio de impresión en " + printApiBase() };
    }
  };
  // Impresoras instaladas en el equipo (null si el servicio no responde).
  Vue.prototype.api_print_printers = async function () {
    try {
      const response = await fetchWithTimeout(printApiBase() + "Print/printers", 4000);
      if (!response.ok) return null;
      const list = await response.json();
      return Array.isArray(list) ? list.filter(p => typeof p === "string") : null;
    } catch (error) {
      return null;
    }
  };
  // Estado de un lote en el API: "pending" | "submitted" | "rejected" | "unconfirmed" | "unknown" | null (sin respuesta).
  Vue.prototype.api_print_job = async function (jobId) {
    try {
      const response = await fetchWithTimeout(printApiBase() + "Print/jobs/" + encodeURIComponent(jobId), 3000);
      if (response.status === 404) return "unknown";
      if (!response.ok) return null;
      const data = await response.json();
      return (data && data.status) || null;
    } catch (error) {
      return null;
    }
  };
  Vue.prototype.api_print_ticket = async function (body) {
    const cabecera = {
      "Content-Type": "application/json",

    };

    const request = {
      method: "POST",
      headers: cabecera,
      body: JSON.stringify(body),
    };
    const response = await fetch("http://128.1.0.171:8020/api/" + "PrintTicketPos", request);
    return response;
  };
  Vue.prototype.api_Get = async function (link) {

    const store = require('../store').default;
    const token = store.getters["auth/getToken"]

    const cabecera = {
      "Content-Type": "application/json",
      Authorization: "bearer " + token
    };

    const request = { method: "GET", headers: cabecera };
    const response = await fetch(url + link, request);

    return response;
  };
  //consulta POST global---------------------------------------------------------------------
  Vue.prototype.api_Post = async function (link, body) {
    const store = require('../store').default;
    const token = store.getters["auth/getToken"]

    const cabecera = {
      "Content-Type": "application/json",
      Authorization: "bearer " + token
    };


    const request = {
      method: "POST",
      headers: cabecera,
      body: JSON.stringify(body),
    };
    const response = await fetch(url + link, request);
    return response;
  };
  //consulta POST global---------------------------------------------------------------------
  Vue.prototype.api_PostPdf = async function (link, body) {
    const store = require('../store').default;
    const token = store.getters["auth/getToken"]

    const cabecera = {
      "Content-Type": "application/json",
      Authorization: "bearer " + token
    };

    const cabeceraPdf = {
      "Content-Type": "application/json",
      Authorization: "bearer " + token
    };
    const request = {
      method: "POST",
      headers: cabeceraPdf,
      body: JSON.stringify(body),
    };
    const response = await fetch(url + link, request);
    return response;
  };
  //consulta PUT global---------------------------------------------------------------------
  Vue.prototype.api_Put = async function (link, body) {
    const store = require('../store').default;
    const token = store.getters["auth/getToken"]

    const cabecera = {
      "Content-Type": "application/json",
      Authorization: "bearer " + token
    };

    const request = {
      method: "PUT",
      headers: cabecera,
      body: JSON.stringify(body),
    };
    const response = await fetch(url + link, request);
    return response;
  };
  //consulta PATCH global---------------------------------------------------------------------
  Vue.prototype.api_Patch = async function (link, body) {
    const store = require('../store').default;
    const token = store.getters["auth/getToken"]

    const cabecera = {
      "Content-Type": "application/json",
      Authorization: "bearer " + token
    };

    const request = {
      method: "PATCH",
      headers: cabecera,
      body: JSON.stringify(body),
    };
    const response = await fetch(url + link, request);
    return response;
  };
  //consulta DELETE global---------------------------------------------------------------------
  Vue.prototype.api_Delete = async function (link) {
    const store = require('../store').default;
    const token = store.getters["auth/getToken"]

    const cabecera = {
      "Content-Type": "application/json",
      Authorization: "bearer " + token
    };

    const request = { method: "DELETE", headers: cabecera };
    const response = await fetch(url + link, request);
    return response;
  };

  Vue.prototype.clearInputFilter = function (code, fill) {
    let codeClear = code.replaceAll("'", "").replaceAll("-", "").replaceAll("/", "").replaceAll("*", "").replaceAll('%', '').replaceAll(' ', '');
    if (fill > 0) {
      codeClear = this.filLeft(codeClear, fill, "0");
    }
    return codeClear;
  }

  //combo generico (solo contiene id y description)--------------------------------------------
  Vue.prototype.g_ComboGeneric = async function (link) {
    let items = [];
    let result = await this.api_Get(link);
    let data = await result.json();
    data.forEach((element) =>
      items.push({
        value: element.id,
        text: element.description,
      })
    );
    return items;
  };



  // For tax-free entities (zonas francas) with cf
  Vue.prototype.clearInputFilter = function (code, fill) {
    if (!code) {
      return code;
    }
    let codeClear = code.replaceAll("'", "").replaceAll('"', "").replaceAll("-", "").replaceAll("/", "").replaceAll("*", "").replaceAll('%', '').replaceAll(' ', '');
    if (fill > 0) {
      codeClear = this.filLeft(codeClear, fill, "0");
    }
    return codeClear;
  }
  Vue.prototype.loadingpage = function () {
    let loader = this.$loading.show({
      // Pass props by their camelCased names
      container: this.$refs.loadingContainer,
      canCancel: false, // default false
      onCancel: this.yourCallbackMethod,
      color: "#007bff",
      loader: "dots",
      width: 150,
      height: 150,
      backgroundColor: "#000000",
      opacity: 0.2,
      zIndex: 999,
    });

    return loader;
  };
  Vue.prototype.time_line_config = function (type, status_id) {
    if (type == 2 && status_id === 3) {
      return { color: 'deep-orange accent-3', icon: 'cancel' }
    }
    if (status_id === 1) {
      return { color: 'blue-grey lighten-1', icon: 'auto_delete' }
    }
    if (status_id === 2) {
      return { color: 'amber accent-2', icon: 'hourglass_empty' }
    }
    if (status_id === 3) {
      return { color: 'orange accent-4', icon: 'vertical_align_bottom' }
    }
    if (status_id === 4) {
      return { color: 'green darken-1', icon: 'download_done' }
    }
    if (status_id === 5) {
      return { color: 'teal darken-2', icon: 'app_registration' }
    }
    return { color: 'blue-grey lighten-1', icon: 'auto_delete' }
  };


  Vue.prototype.time_line_orders = function (type) {
    if (type === 1) {
      return { color: 'grey', icon: 'auto_delete' }
    }
    if (type === 2) {
      return { color: 'amber', icon: 'hourglass_empty' }
    }
    if (type === 3) {
      return { color: 'blue', icon: 'vertical_align_bottom' }
    }
    if (type === 4) {
      return { color: 'green', icon: 'download_done' }
    }
    if (type === 5) {
      return { color: 'green', icon: 'download_done' }
    }
    if (type === 6) {
      return { color: 'green', icon: 'download_done' }
    }
    if (type === 7) {
      return { color: 'green', icon: 'download_done' }
    }
    if (type === 8) {
      return { color: 'green', icon: 'download_done' }
    }
    if (type === 9) {
      return { color: 'green', icon: 'download_done' }
    }
    if (type === 10) {
      return { color: 'green', icon: 'download_done' }
    }
    if (type === 11) {
      return { color: 'red', icon: 'gpp_bad' }
    }
    if (type === 12) {
      return { color: 'brown', icon: 'disabled_by_default' }
    }
    if (type === 13) {
      return { color: 'orange', icon: 'warehouse' }
    }
    if (type === 14) {
      return { color: 'cyan', icon: 'lock' }
    }
    if (type === 15) {
      return { color: 'yellow', icon: 'print' }
    }

  };
  Vue.prototype.getFlag = function (type) {
    if (type === 1) {
      return 'do'
    }
    if (type === 2) {
      return 'ht'
    }
    if (type === 3) {
      return 'us'
    }
    if (type === 4) {
      return 'es'
    }


  };

  //combo turnos------------------------------------------------------------------------------
  Vue.prototype.g_Shifts = async function () {
    let itemShift = [];
    let result = await this.api_Get("humanResource/shifts");
    let data = await result.json();
    data.forEach((element) =>
      itemShift.push({
        value: element.id,
        text: element.description_long,
        horas: element.work_hours,
        real_hours: element.real_hours,
      })
    );
    return itemShift;
  };

  Vue.prototype.getImage = function (image) {
    let storageUrl = ''
    if (image != undefined) {
      storageUrl = `${url_pocketbase}/api/files/${image.collectionId}/${image.id}/${image.documents}`;

    }
    return storageUrl;
  };
  //combo bancos------------------------------------------------------------------------------
  Vue.prototype.g_Bancos = async function () {
    let itemsBanks = [];
    let result = await this.api_Get("humanResource/banks");
    let dataBanks = await result.json();

    return dataBanks;
  };

  //tipo cuenta------------------------------------------------------------------------------
  Vue.prototype.g_type_account = async function () {
    let result = await this.api_Get("humanResource/accounts/types");
    let dataTypeAccount = await result.json();

    return dataTypeAccount;
  };

  //combo tipos dni---------------------------------------------------------------------------
  Vue.prototype.g_dniTypes = async function () {
    let itemsDni = [];
    let result = await this.api_Get("recruitment/dni_types");
    let data = await result.json();
    data.forEach((element) =>
      itemsDni.push({
        value: element.id,
        text: element.dni_type_description,
        contry_id: element.country_id,
      })
    );
    return itemsDni;
  };
  //combo nacionalidades-----------------------------------------------------------------------
  Vue.prototype.g_nacionalities = async function () {
    let itemsNationalities = [];
    let result = await this.api_Get("recruitment/nationalities");
    let data = await result.json();
    data.forEach((element) =>
      itemsNationalities.push({
        value: element.id,
        text: element.nationality_description,
        country_id: element.country_id,
      })
    );
    return itemsNationalities;
  };
  //combo companies--------------------------------------------------------------------------
  Vue.prototype.g_companies = async function () {
    let result = await this.api_Get("humanResource/companies");
    return await result.json();
  };
  //combo ars--------------------------------------------------------------------------
  Vue.prototype.g_ars = async function () {
    let result = await this.api_Get("humanResource/ars");
    return await result.json();
  };
  //combo Bussines unit-----------------------------------------------------------------------
  Vue.prototype.g_bussines = async function () {
    let result = await this.api_Get("humanResource/bussines_unit");

    return await result.json();
  };
  //combo monedas--------------------------------------------------------------------------
  Vue.prototype.g_currencies = async function () {
    let result = await this.api_Get("humanResource/currencies");
    let dataCurrencies = await result.json();

    return dataCurrencies;
  };
  //combo nlocations-----------------------------------------------------------------------
  Vue.prototype.g_locations = async function () {
    let itemsLocations = [];
    let result = await this.api_Get("humanResource/locations");
    let data = await result.json();
    for (var item of data) {

      // if (locationsAccess.includes(item.id)) {
      itemsLocations.push({
        value: item.id,
        text: item.desc_loc_long,
        bus_id: item.bus_id,
        condicion: item.bus_id,
        catalogue_id: item.catalogue_id,

        description_short: item.desc_loc_short,
      });
      // }
    }

    return itemsLocations;
  };
  //combo departamentos------------------------------------------------------------------------
  Vue.prototype.g_departments = async function () {
    let itemsDepartment = [];
    let result = await this.api_Get("humanResource/departments");
    let data = await result.json();


    data?.forEach((element) =>
      itemsDepartment.push({
        value: element.id,
        routes: element.department_routes,
        text:
          element.department_names.length > 0
            ? element.department_names[0].department_names_description
            : "Departamento (" + element.id + ") Sin descripcion",
      })
    );

    return itemsDepartment;
  };

  //combo tipos categorias-------------------------------------------------------------------
  Vue.prototype.g_typesCategories = async function () {
    let itemType = [];
    let result = await this.api_Get(
      "humanResource/employees/actions/categoryTypes"
    );
    let data = await result.json();
    data.forEach((element) =>
      itemType.push({
        value: element.id,
        text: element.employee_type_names_description,
      })
    );
    return itemType;
  };

  //combo grupos de pago con location2----------------------------------------------------------------------
  Vue.prototype.g_payGroupsWithLocations = async function () {
    let itemPayGroup = [];

    let result = await this.api_Post("humanResource/payGroups2", {
      filters: locationsAccess,
    });
    let data = await result.json();
    data.forEach((element) =>
      itemPayGroup.push({
        value: element.id,
        text: element.description_long,
        condicion: element.location_id,
      })
    );
    return itemPayGroup;
  };
  //combo semanas sin confrimar---------------------------------------------------------------------
  Vue.prototype.g_paryrollWeeks = async function () {
    let itemsWeek = [];
    let result = await this.api_Get("payroll/payrollWeeks");
    let data = await result.json();

    data.forEach((element) => {
      if (element.is_payroll_opened == false) {
        itemsWeek.push({
          value: element.date_begin,
          text:
            "Semana (" +
            element.description +
            ") desde " +
            element.date_begin +
            " hasta " +
            element.id,
          date_end: element.id,
        });
      }
    });
    return itemsWeek;
  };
  //obtiene el paygroup de un location----------------------------------------------------------------------
  Vue.prototype.g_payGroupWithLocation = async function (location_id) {
    let result = await this.api_Get(
      "humanResource/getPaygroupWhitLocation/" + location_id
    );
    let data = await result.json();
    return data[0].id;
  };
  //combo semanas todas las semanas---------------------------------------------------------------------
  Vue.prototype.g_paryrollAllWeeks = async function () {
    let itemsWeek = [];
    let result = await this.api_Get("payroll/payrollWeeks");
    let data = await result.json();

    data.forEach((element) => {
      itemsWeek.push({
        value: element.date_begin,
        text:
          "Semana (" +
          element.description +
          ") desde " +
          element.date_begin +
          " hasta " +
          element.id,
        date_end: element.id,
      });
    });
    return itemsWeek;
  };

  //convierte primera letra mayuscula y el resto minuscula en cada palabra de un string------------
  Vue.prototype.firtsLetterMinRestUp = function (string) {
    let stringSplit = string.split(" ");
    let newString = "";
    for (var item in stringSplit) {
      newString +=
        stringSplit[item].charAt(0).toUpperCase() +
        stringSplit[item].slice(1).toLowerCase() +
        " ";
    }
    return newString;
  };
  Vue.prototype.filLeft = function (str, length, add) {
    if (str == undefined) {
      return ''
    }
    //rellena caracteres a la izauierda
    while (str.length < length) {
      str = add + str;
    }
    return str;
  };
  Vue.prototype.filRight = function (str, length, add) {
    //rellena caracteres a la derecha
    while (str.length < length) {
      str += add;
    }
    return str;
  };

  Vue.prototype.ViewWarehouse = function (warehouse_id) {
    //rellena caracteres a la derecha
    this.$router.push({
      name: "ViewWarehouse",
      params: { id: warehouse_id },
    });
  };
  Vue.prototype.viewEntity = function (entity_id, type) {
    //rellena caracteres a la derecha
    if (!this.$store.state.auth.globalFeatures.includes('CNN-011')) {
      return
    }

    if (type == true) {
      let route = this.$router.resolve({
        name: "ViewEntitys",
        params: { id: entity_id },
      });
      window.open(route.href);
    }
    else {
      this.$router.push({
        name: "ViewEntitys",
        params: { id: entity_id },
      });
    }
  };

  Vue.prototype.showInvoice = function (invoice_id, type) {
    if (type == true) {
      let route = this.$router.resolve({
        name: "ViewInvoice",
        params: { id: invoice_id },
      });
      window.open(route.href);
    }
    else {
      this.$router.push({
        name: "ViewInvoice",
        params: { id: invoice_id },
      });
    }

  };
  Vue.prototype.showNote = function (invoice_id, type) {
    if (type == true) {
      let route = this.$router.resolve({
        name: "ViewNote",
        params: { id: invoice_id },
      });
      window.open(route.href);
    }
    else {
      this.$router.push({
        name: "ViewNote",
        params: { id: invoice_id },
      });
    }

  };
  Vue.prototype.viewReception = function (order_id, id, is_blank) {
    if (is_blank) {
      const routeData = this.$router.resolve({
        name: "ViewReceptions",
        params: { order_id: order_id, id: id }
      });
      window.open(routeData.href, "_blank");
      return
    }
    this.$router.push({
      name: "ViewReceptions",

      params: { order_id: order_id, id: id },
    })

  };
  Vue.prototype.showPayments = function (number, type) {


    let route = this.$router.resolve({
      name: type == 1 ? "ViewPaymentsCxC" : "ViewPaymentsCxP",
      params: { id: number },
    });


    window.open(route.href);
    // this.$router.push({
    //   name: "ViewTransactions",

    //     params: { id: btoa(number)},
    //   })
  };
  // ¿El usuario tiene alguno de estos permisos (features)? Acepta un código o un arreglo.
  Vue.prototype.hasFeature = function (codes) {
    const features = this.$store.state.auth.globalFeatures || [];
    return [].concat(codes).some((code) => features.includes(code));
  };

  Vue.prototype.showTransactions = function (number, type) {


    let route = this.$router.resolve({
      name: type === 1 ? "ViewTransactionsCxC" : "ViewTransactionsCxP",
      params: { id: number },
    });


    window.open(route.href);
    // this.$router.push({
    //   name: "ViewTransactions",

    //     params: { id: btoa(number)},
    //   })
  };
  Vue.prototype.showOrder = function (number, types, typeb) {

    var typesb = 0
    if (typeb == 2) {
      typesb = 'a2xrbWFuaW4Rtgsdsx'
    }
    var type = 'adsa'
    if (types == true) {
      type = 'a2xrbWFuaW4'
    }

    this.$router.push({
      name: "ViewOrders",

      params: { id: number, type: type, typeb: typesb },

    });
  };
  Vue.prototype.showQuotation = function (number) {

    this.$router.push({
      name: "ViewOrders",
      params: { id: number },
    });
  };

  Vue.prototype.getIconPayments = function (type) {


    if (type == 1) {
      return "mdi-cash"
    }
    if (type == 2) {
      return "mdi-credit-card"
    }
    if (type == 3) {
      return "mdi-bank-check"
    }
    if (type == 4) {
      return "mdi-bank-transfer"
    }
    if (type == 5) {
      return "mdi-bank-transfer"
    }
    if (type == 6) {
      return "mdi-bank-transfer"
    }
    if (type == 7) {
      return "mdi-bank-transfer"
    }


  };

  Vue.prototype.getIconBank = function (type) {


    if (type == 20) {
      return "popular.jpg"
    }
    if (type == 21) {
      return "banreservas.png"
    }

    if (type == 46) {
      return "firsthorizon.png"
    }
    if (type == 2) {
      return "mdi-credit-card"
    }

    return "default.png"
  };

  Vue.prototype.beforeRoute = function () {
    window.history.back();
  };
  Vue.prototype.clearEmployeeCodeToFilter = function (code) {
    return this.filLeft(code.replaceAll("'", "").replaceAll("-", "").replaceAll("/", "").replaceAll("*", "").replaceAll('%', ''), 6, "0");
  }
  Vue.prototype.get_storage = function (item) {
    if (!item) return '';
    if (item.key) return this.spaces_file_url(item.key);
    if (item.url) return item.url;
    const filename = Array.isArray(item.documents) ? item.documents[0] : (item.documents || '');
    return pb.getFileUrl(item, filename);
  };

  Vue.prototype.delete_file_storage = async function (bucket, filesRecived) {
    const createdRecord = await pb.records.delete(bucket, filesRecived);
    return createdRecord;
  };

  // Vue.prototype.delete_file_storage = async function (bucket, filesRecived) {
  //   const result = await pb.collection(bucket).delete(filesRecived);
  //  return result;
  // };


  Vue.prototype.upload_images = async function (bucket, filesRecived) {

    const formData = new FormData();

    // listen to file input changes and add the selected files to the form data
    for (let file of filesRecived.files) {
      formData.append("documents", file);
    }

    // upload and create new record
    const createdRecord = await pb.collection(bucket).create(formData);

    return createdRecord;
  };

  /**
   * Upload a single file to DigitalOcean Spaces via the backend.
   * @param {File} file - The File object to upload
   * @param {string} folder - Target folder in the bucket (e.g. 'signatures', 'orders')
   * @returns {Promise<{ url: string, key: string }>}
   */
  Vue.prototype.spaces_file_url = function (key) {
    return `${url}shopping/spaces_file?key=${encodeURIComponent(key)}`;
  };

  Vue.prototype.upload_to_spaces = async function (file, folder = 'orders') {
    const store = require('../store').default;
    const token = store.getters["auth/getToken"];

    const formData = new FormData();
    formData.append('file', file, file.name);

    const response = await fetch(`${url}shopping/upload_to_spaces?folder=${folder}`, {
      method: 'POST',
      headers: { Authorization: 'bearer ' + token },
      body: formData,
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Error uploading file to storage');
    }

    return response.json();
  };

  Vue.prototype.delete_from_spaces = async function (key) {
    const store = require('../store').default;
    const token = store.getters["auth/getToken"];

    const response = await fetch(`${url}shopping/delete_from_spaces`, {
      method: 'POST',
      headers: { Authorization: 'bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ key }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Error deleting file from storage');
    }

    return response.json();
  };

  Vue.prototype.currencyFormat = function (number) {
    // No redondear, solo truncar a 2 decimales
    if (number == undefined || number === 0) {
      return "0.00";
    }

    // Truncar a 2 decimales sin redondear
    const factor = Math.pow(10, 2);
    const truncated = Math.round(number * factor) / factor;

    // Formatear con separadores de miles pero sin redondear
    let parts = truncated.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Asegurar que siempre hay 2 decimales
    if (parts.length === 1) {
      parts.push("00");
    } else if (parts[1].length === 1) {
      parts[1] += "0";
    } else if (parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2);
    }

    return parts.join(".");
  };
  Vue.prototype.intToColum = function (number) {
    let numberReturn = 0;
    if (number - parseInt(number) > 0) {
      numberReturn = parseInt(number) + 1;
    } else {
      numberReturn = number;
    }
    return numberReturn;
  };
  Vue.prototype.textFormater = function (text) {
    let arrayWords = text.toLowerCase().split(" ");

    for (var key in arrayWords) {
      arrayWords[key] =
        arrayWords[key].charAt(0).toUpperCase() + arrayWords[key].slice(1);
    }

    return arrayWords.join(" ");
  };

  Vue.prototype.generateCsvFile = function (filename, csv) {
    var csvFile;
    var downloadLink;
    csvFile = new Blob([csv], { type: "text/csv" });
    downloadLink = document.createElement("a");
    // downloadLink.setAttribute("href","data:text/plain;charset=utf-8," + encodeURIComponent(csv));
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  Vue.prototype.deleteDiacriticos = function (texto) {
    return texto.replaceAll(',', '').normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  };
  Vue.prototype.generateTxtFile = function (filename, text) {
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };
  Vue.prototype.monthsArray = [
    { value: 1, text: "Enero" },
    { value: 2, text: "Febrero" },
    { value: 3, text: "Marzo" },
    { value: 4, text: "Abril" },
    { value: 5, text: "Mayo" },
    { value: 6, text: "Junio" },
    { value: 7, text: "Julio" },
    { value: 8, text: "Agosto" },
    { value: 9, text: "Septiembre" },
    { value: 10, text: "Octubre" },
    { value: 11, text: "Noviembre" },
    { value: 12, text: "Diciembre" },
  ];

}; // End of exports.install
